function parseBooleanFlag(value, defaultValue = false) {
    if (typeof value !== 'string') {
        return defaultValue;
    }

    const normalized = value.trim().toLowerCase();
    if (['1', 'true', 'yes', 'on'].includes(normalized)) {
        return true;
    }

    if (['0', 'false', 'no', 'off'].includes(normalized)) {
        return false;
    }

    return defaultValue;
}

export const kbPropertiesCrudEnabled = parseBooleanFlag(
    process.env.REACT_APP_KB_PROPERTIES_CRUD_ENABLED,
    true
);

export const kbAliasesCrudEnabled = parseBooleanFlag(
    process.env.REACT_APP_KB_ALIASES_CRUD_ENABLED,
    true
);
